import * as React from "react";

import primaryColour from "../../constants";

function SvgIdle(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.0731 3.99878C11.5821 3.99878 11.184 4.39681 11.184 4.8878C11.184 5.37879 11.5821 5.77681 12.0731 5.77681C13.0826 5.77681 14.0769 6.02838 14.9682 6.50979C15.8595 6.99123 16.6206 7.68793 17.1833 8.53898C17.7461 9.39007 18.0928 10.369 18.1923 11.3891C18.2917 12.4091 18.1406 13.4381 17.7527 14.3845C17.3647 15.3308 16.7523 16.1649 15.9703 16.8134C15.1885 17.4618 14.2612 17.9048 13.2709 18.1038C12.2806 18.3029 11.257 18.2521 10.2906 17.9559C9.79465 17.8038 9.32146 17.5895 8.88158 17.3192C8.46327 17.0621 7.91576 17.1928 7.65868 17.6111C7.4016 18.0294 7.53231 18.5769 7.95062 18.834C8.51799 19.1827 9.12881 19.4594 9.76949 19.6558C11.0182 20.0386 12.3413 20.1043 13.6213 19.847C14.9013 19.5897 16.0979 19.0175 17.1054 18.182C18.1128 17.3465 18.8999 16.2736 19.3978 15.0588C19.8958 13.8441 20.0894 12.5244 19.9619 11.2166C19.8344 9.90873 19.3897 8.65219 18.6664 7.55831C17.9431 6.46439 16.9634 5.56664 15.8132 4.94539C14.663 4.32411 13.3783 3.99878 12.0731 3.99878Z"
        fill={fill}
      />
      <path
        d="M12.8612 8.44387C12.8612 7.95288 12.4632 7.55485 11.9722 7.55485C11.4812 7.55485 11.0832 7.95288 11.0832 8.44387V11.895L8.01852 13.4273C7.57936 13.6469 7.40136 14.1809 7.62094 14.6201C7.84051 15.0592 8.37452 15.2372 8.81368 15.0176L12.8612 12.9939V8.44387Z"
        fill={fill}
      />
      <path
        d="M5.39434 14.4401C5.81913 14.1938 6.36309 14.3386 6.60933 14.7633C6.85557 15.1881 6.71083 15.7321 6.28605 15.9783C5.86127 16.2246 5.3173 16.0798 5.07106 15.6551C4.82483 15.2303 4.96956 14.6863 5.39434 14.4401Z"
        fill={fill}
      />
      <path
        d="M5.77802 11.6219C5.78044 11.1309 5.38437 10.7309 4.89338 10.7285C4.4024 10.7261 4.00242 11.1222 4.00001 11.6132C3.9976 12.1042 4.39367 12.5041 4.88465 12.5065C5.37564 12.509 5.77561 12.1129 5.77802 11.6219Z"
        fill={fill}
      />
      <path
        d="M6.2926 7.32061C6.71695 7.56759 6.86074 8.11181 6.61376 8.53616C6.36678 8.96051 5.82256 9.10429 5.39821 8.85731C4.97386 8.61033 4.83007 8.06611 5.07705 7.64176C5.32403 7.21741 5.86825 7.07363 6.2926 7.32061Z"
        fill={fill}
      />
      <path
        d="M8.89315 6.26078C9.31884 6.01611 9.46558 5.47268 9.22091 5.04699C8.97624 4.62131 8.43281 4.47457 8.00712 4.71924C7.58144 4.96391 7.43469 5.50734 7.67936 5.93302C7.92403 6.35871 8.46746 6.50545 8.89315 6.26078Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgIdle;
